import type { NavItem } from '../../components/common/AppSidebar';
import { DEFAULT_CAMPAIGN_TAB, type CampaignTab } from '../search';

/**
 * A URL can name a tab that isn't in the nav (a stale #shopify link when
 * Shopify is disabled, a discovery deep link for a role without discovery);
 * fall back to the default tab so a hidden one is never rendered. `null` (tab
 * not decided yet) stays `null`.
 */
export function resolveVisibleTab(tab: CampaignTab | null, navItems: NavItem[]): CampaignTab | null {
  if (tab === null) return null;
  const isTabVisible = navItems.some((item) => item.id === tab);
  return isTabVisible ? tab : DEFAULT_CAMPAIGN_TAB;
}
